import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { SmoothScroll } from "./components/site/SmoothScroll";
import { NavCorp } from "./components/site/NavCorp";
import { Footer } from "./components/site/Footer";
import { AuthProvider } from "./lib/auth";
import Home from "./pages/Home";
import ProductPage from "./pages/ProductPage";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import AdminNews from "./pages/AdminNews";
import News from "./pages/News";
import NewsPost from "./pages/NewsPost";

const Shell = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <SmoothScroll />
      {!isAdmin && <NavCorp />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products/:slug" element={<ProductPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/:slug" element={<NewsPost />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/news" element={<AdminNews />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {!isAdmin && <Footer />}
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Shell />
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
